
import { Component, Input, OnInit, inject } from '@angular/core';
import {
  ControlValueAccessor,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { ErrorStateMatcher, MAT_DATE_FORMATS } from '@angular/material/core';
import {
  MatDatepickerInputEvent,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { BaseDatepickerService } from '../services/base-datepicker.service';
import { DefaultErrorStateMatcher } from '../validation/DefaultErrorStateMatcher';
import { CalendarHeaderComponent } from './calendar-header/calendar-header.component';

@Component({
    selector: 'cerrix-datepicker',
    imports: [
    ErrorMessagesPipe,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule
],
    templateUrl: './cerrix-datepicker.component.html',
    styleUrl: './cerrix-datepicker.component.scss',
    providers: []
})
export class CerrixDatepickerComponent implements OnInit, ControlValueAccessor {
  @Input() public value: Date | undefined = undefined;
  @Input() public placeholder: string = '';
  @Input() public disabled: boolean = false;
  @Input() public minDate: Date | undefined = undefined;
  @Input() public maxDate: Date | undefined = undefined;
  @Input() public dataUiid: string = "undefined"

  protected errorMatcher!: ErrorStateMatcher;
  protected ngControl = inject(NgControl, { optional: true, self: true });

  private readonly dateFormats = inject(MAT_DATE_FORMATS);
  private readonly datepickerService = inject(BaseDatepickerService, {
    optional: true,
  });

  protected readonly calendarHeader = CalendarHeaderComponent;

  private onValueChange = (value: Date | undefined) => {};
  private onTouched = () => {};

  public writeValue(value: Date): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: Date | undefined) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
      this.errorMatcher = new DefaultErrorStateMatcher();
    }
  }

  public ngOnInit() {
    if (this.datepickerService) {
      const dateFormat = this.datepickerService.getDateFormat();
      this.dateFormats.parse.dateInput = dateFormat;
      this.dateFormats.display.dateInput = dateFormat;

      if (!this.placeholder) {
        this.placeholder = dateFormat;
      }

      this.datepickerService.setLocale();
    }
  }

  protected onDateChange(event: MatDatepickerInputEvent<Date>) {
    this.value = event.value ?? undefined;
    this.onValueChange(this.value);
  }
}
